//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'WFNS',
  data () {
    return {
      defaultJson: {
        "Glasgow Coma Scale": "Glasgow 昏迷评分",
        "Presence of Motor Deficit": "运动障碍",
        "WFNS %@": "WFNS：%@"
      },
      form: {
        gcs:'',
        deficit:'0'
      },
      hasScore: false,
      disabled: false,
      descTxt:'',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // g + p + r  form.
        // gcs < 7 ? 5 : (gcs < 13 ? 4 : (gcs < 15 ? (deficit ? 3 : 2) : 1))		
        let result = form.gcs < 7 ? 5 : (form.gcs < 13 ? 4 : (form.gcs < 15 ? (form.deficit ? 3 : 2) : 1))
        
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/WFNS.vue